import React from "react";
import { MapPin } from "lucide-react";

// Cabecera de DESTINO operativo (espacio_id real). Se pinta antes de la primera parada de cada destino con >1 trabajo.
export function destinoDeParada(destinos, idx) {
  return (destinos || []).find((d) => d.paradas_idx?.[0] === idx) || null;
}

export function DestinoHeader({ destino, compacto }) {
  if (!destino || destino.n_trabajos <= 1) return null;
  const dir = [destino.direccion, destino.cp, destino.ciudad].filter(Boolean).join(", ");
  return (
    <div className={`rounded-lg border border-sky-500/40 bg-sky-500/10 ${compacto ? "px-3 py-1.5" : "px-4 py-2"} flex items-start gap-2`}
         data-testid={`destino-${destino.orden_destino}`}>
      <MapPin className="w-4 h-4 text-sky-300 mt-0.5 shrink-0" />
      <div className="min-w-0">
        <div className="text-xs uppercase tracking-wider text-sky-300 font-bold">
          Destino {destino.orden_destino} · {destino.nombre}
          <span className="ml-2 text-sky-200/80 font-semibold normal-case tracking-normal" data-testid={`destino-${destino.orden_destino}-trabajos`}>
            {destino.n_trabajos} trabajos · {destino.n_piezas} piezas · paradas {destino.paradas_ordenes.map((o) => `#${o}`).join(", ")}
          </span>
        </div>
        {dir && <div className="text-[11px] text-zinc-400 truncate">{dir}</div>}
        {destino.clientes?.length > 1 && <div className="text-[11px] text-zinc-500">Clientes: {destino.clientes.join(" · ")}</div>}
        {destino.disperso && <div className="text-[11px] text-red-300">Trabajos no consecutivos en la ruta · revisa el orden</div>}
      </div>
    </div>
  );
}

export function DestinosResumen({ ruta }) {
  const nd = ruta?.n_destinos ?? ruta?.destinos?.length;
  if (!nd) return null;
  return (
    <span className="inline-flex items-center gap-1 text-xs text-sky-300" data-testid="destinos-resumen">
      <MapPin className="w-3 h-3" /> {nd} destinos / {(ruta.paradas || []).length} trabajos
    </span>
  );
}
